import { rankWith, isControl, scopeEndsWith, and } from '@jsonforms/core';

export const dateWonTester = rankWith(
  3, // rank should be higher than the default renderers
  and(isControl, scopeEndsWith('won_date')) // replace 'yourPath' with the appropriate value
);
